import React from 'react';
import theme, { Theme } from '@design/theme';
import { query } from '@design/templateFns';
import styled, { ThemeProvider } from 'styled-components';
import GlobalStyle from './GlobalStyle';
import { SimpleComponent } from '@util/types';
import { GlobalSiteHeaderContextProvider } from '@components/GlobalSiteHeader/GlobalSiteHeaderContext';
import { SnackbarProvider } from '@components/Snackbar';
import { ConfigProviderProps, ConfigProvider } from 'antd';

export interface LayoutProps {
  theme?: Theme;
  preview?: boolean;
}

export const Container = styled.div<LayoutProps>`
  // display: flex;
  // flex-flow: column nowrap;
  // justify-content: flex-start;
  // align-items: center;
  // position: absolute;
  // top: 0;
  // right: 0;
  // left: 0;
  // min-height: 100vh;
  // overflow: auto;
  ${({ preview }) => {
    if (preview) {
      return { border: 'dashed orange 5px' };
    }
  }}
`;

const Layout: SimpleComponent<LayoutProps> = (props) => {
  const _theme = props.theme || theme;

  const antdConfig: ConfigProviderProps = {
    theme: {
      token: {
        colorPrimary: '#e60000',
      },
    },
  };

  return (
    <GlobalSiteHeaderContextProvider>
      <SnackbarProvider>
        <ThemeProvider theme={_theme}>
          <GlobalStyle />
          <ConfigProvider {...antdConfig}>
            <Container {...props} />
          </ConfigProvider>
        </ThemeProvider>
      </SnackbarProvider>
    </GlobalSiteHeaderContextProvider>
  );
};
export default Layout;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 15px;

  @media (min-width: ${query.atLeast('tablet')}) {
    grid-template-columns: repeat(3, 3fr);
  }

  @media (min-width: ${query.atLeast('desktop')}) {
    grid-template-columns: repeat(4, 4fr);
  }
`;

export const Hr = styled.hr`
  margin-top: 2rem;
  margin-bottom: 3rem;
`;

export const Spacer = styled.div`
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  display: inline-flex;
`;
